const TriggerTransferGivenUpPointReducers = (state = false, action) => {
  switch (action.type) {
    case "triggerTransferGivenUpPoint":
      return action.payload;

    default:
      return state;
  }
};
export default TriggerTransferGivenUpPointReducers;
